import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useRef, useEffect } from "react";
const MouseMoveContext = createContext({ current: false });
function useMouseMoveContext() {
  return useContext(MouseMoveContext);
}
function useMouseMove(observedElementRef) {
  const movingTimeout = useRef(0);
  const mouseActive = useRef(false);
  useEffect(() => {
    if (!observedElementRef.current) {
      return;
    }
    const element = observedElementRef.current;
    const mouseMoveListener = () => {
      mouseActive.current = true;
      window.clearTimeout(movingTimeout.current);
      movingTimeout.current = window.setTimeout(() => {
        mouseActive.current = false;
      }, 300);
    };
    element.addEventListener("mousemove", mouseMoveListener);
    return () => {
      element.removeEventListener("mousemove", mouseMoveListener);
    };
  }, [observedElementRef]);
  return mouseActive;
}
function MouseMoveProvider({
  elementRef,
  children
}) {
  const mouseIsMoving = useMouseMove(elementRef);
  return /* @__PURE__ */ jsx(MouseMoveContext.Provider, { value: mouseIsMoving, children });
}
export {
  MouseMoveProvider,
  useMouseMove,
  useMouseMoveContext
};
//# sourceMappingURL=useMouseMove.js.map
